import {useAppSelector} from '../../services/redux/store';
export function Loading() {
    return (
      <div className="loading-wrapper">
        <div className="loading-spinner">
          <div className="loading">
            <div></div>
          </div>
        </div>
      </div>
    );
}
